import { Stack } from '@mui/material';
import { FORM_TYPE } from 'src/constants';
import { useAppSelector } from 'src/redux/store';
import { Action5InfoDataGrid } from './Action5InfoDataGrid';
import { AnswerInfoDataGrid } from './AnswerInfoDataGrid';
import { ConfirmInfoDataGrid } from './ConfirmInfoDataGrid';

export const EnqueteConfirmTab: React.FC = () => {
  const surveyDetailData = useAppSelector((state) => state.enqueteAnswer.surveyDetailData);
  // アンケートフォーム種別
  const enqueteType = surveyDetailData.surveyHeader?.formType;

  return (
    <Stack spacing={5}>
      <AnswerInfoDataGrid />
      <ConfirmInfoDataGrid surveyDetailId={surveyDetailData?.id} />
      {enqueteType === FORM_TYPE.COMPLIA && <Action5InfoDataGrid />}
    </Stack>
  );
};
